<template lang="html">
  <div class="newOrder">
    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
    <circle-spin v-if="!dataShipment"></circle-spin>
    <div  v-if="dataShipment">
      <div class="orden-subtitulo text-title">
        <h1>Evaluación de embarque # {{dataShipment.id}}</h1>
      </div>

      <div class="details-tab">
        <div id="accordion">
          <div class="card">
            <div
              class="card-header collapsed"
              id="headingFour"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              <div class="details-text">
                <h1>
                  <i class="fa" aria-hidden="true"></i>
                </h1>
                <p>Datos del embarque</p>
              </div>
            </div>

            <div
              id="collapseFour"
              class="collapse show"
              aria-labelledby="headingFour"
              data-parent="#accordion"

            >
              <div class="card-body">
                <div class="form-login text-title form-none">
                  <div class="resumen-type" v-if="dataShipment">
                    <div class="resumen_orden">
                      <div class="resumen_titulo">
                        <h1>Descripción</h1>
                      </div>

                      <div class="resumen_content" >
                        <h1>{{dataShipment.attributes.description}}</h1>
                      </div>

                    </div>

                    <div class="resumen_orden">
                      <div class="resumen_titulo">
                        <h1>Destino</h1>
                      </div>

                      <div class="resumen_content" >
                        <h1>{{dataShipment.attributes.destination.attributes.name}}</h1>
                      </div>

                    </div>

                    <div class="resumen_orden">
                      <div class="resumen_titulo">
                        <h1>Operador de llegada</h1>
                      </div>

                      <div class="resumen_content" >
                        <h1>{{dataShipment.attributes.reciever_operator.attributes.username}}</h1>
                      </div>

                    </div>
                    <div class="resumen_orden">
                      <div class="resumen_titulo">
                        <h1>Fecha de salida</h1>
                      </div>

                      <div class="resumen_content" >
                        <h1>{{dataShipment.attributes.arrival_date|spanishDateTime}}</h1>
                      </div>

                    </div>
                    <div class="resumen_orden">
                      <div class="resumen_titulo">
                        <h1>Fecha de llegada</h1>
                      </div>

                      <div class="resumen_content" >
                        <h1>{{dataShipment.attributes.departure_date|spanishDateTime}}</h1>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div
              class="card-header collapsed"
              id="headingSix"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              <div class="details-text">
                <h1>
                  <i class="fa" aria-hidden="true"></i>
                </h1>
                <p>Detalles de equipaje</p>
              </div>
            </div>

            <div
              id="collapseSix"
              class="collapse"
              aria-labelledby="headingSix"
              data-parent="#accordion"
            >
              <div class="card-body">

                  <div class="resumen-type">
                    <div class="vitrinaContainer">
                      <div class="vitrina">
                        <ul class="vitrina-100">
                          <li v-for="luggageItem of dataLuggageCopy">
                            <cardDetailLuggage v-bind:dataLuggage="luggageItem"></cardDetailLuggage>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <div class="card">
          <div class="card-header ">
            <div class="details-text">
              <h1>
                <i class="fa" aria-hidden="true"></i>
              </h1>
              <p>Paquetes</p>
            </div>
          </div>

          <div class="">
            <div class="card-body">

                <div class="resumen-type">
                  <div class="vitrinaContainer">
                    <div class="vitrina">
                      <ul class="vitrina-100">
                        <li v-for="orderItem of dataOrderCopy">
                          <cardEvaluateOrders v-bind:dataPackage="orderItem"  v-bind:fromShipmentFlag="true" @refresh='updateData'></cardEvaluateOrders>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

            </div>
            <div class="text-right">
              <button type="button" class="btn btn-primary" :disabled="!readyToFinish"
              @click="showModalConfirmation">Terminar evaluación</button>
            </div>

          </div>



      </div>

        </div>
        <!-- <div class="text-right" v-if="dataShipment.attributes.status==6 && readyToFinish">
          <a href="#" class="btn btn-secondary btn-lg btn-edit" @click="showModalConfirmation" >Terminar evaluación</a>
        </div> -->


      <b-modal hide-footer hide-header centered id="modalConfirmation" ref="modalConfirmation">
        <div class="modal-Content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmar acción:</h5>
            <button type="button" class="close" aria-label="Close" @click="hideModalConfirmation">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll" id="modal-body">
            <div class="text-center">
              <p>¿Estás seguro que deseas completar esta acción?</p>
            </div>
          </div>

          <div class="modal-footer text-center">
            <button type="button" class="btn btn-primary btn-lg" @click="endEvaluationPackages()">Aceptar</button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="hideModalConfirmation()"
            >Cancelar</button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import cardDetailLuggage from "@/components/prefab/items/card-detail-luggage.vue"
import cardEvaluateOrders from "@/components/prefab/items/card-evaluate-orders.vue"
import { shipmentService } from '@/services/shipment.service'
export default {
  components: {
    cardDetailLuggage,
    cardEvaluateOrders,
    breadcrumb
  },
  props:['id'],
  data(){
    return{
      dataShipment: null,
      dataLuggageCopy: [],
      dataOrderCopy: [],

      nameSection: 'Visualizar embarque',
      listRoutes: [{nameRoute:'shipments-list',titleRoute:'Embarques'},
                  {nameRoute:'shipments-evaluate-package',titleRoute:'Evaluación de embarque'}],
    }
  },
  created(){
    shipmentService.getShipmentDetail(this.id,this.getDataShipment);
  },
  methods:{
    getDataShipment(data){
      this.dataShipment = data;
      this.dataLuggageCopy = this.dataShipment.attributes.luggage_items;
      this.dataOrderCopy = this.dataShipment.attributes.packages;
    },
    async endEvaluationPackages(){
      let aux;
      aux = await shipmentService.changeStateShipment(this.id,'true');
      if(!aux){
        alert("error al cambiar de estado")
        return
      }else{
        this.$router.push({ name: 'shipments-show',params:{ id: this.id}});
      }
    },
    updateData(state){
      if(state){
        shipmentService.getShipmentDetail(this.id,this.getDataShipment);
      }
    },
    hideModalConfirmation() {
      this.$refs.modalConfirmation.hide()
    },
    showModalConfirmation() {
      this.$refs.modalConfirmation.show()
    },
  },
  computed: {
    readyToFinish() {
      let flag = true
      if (this.dataShipment.attributes.status==6){
        for (var i = 0; i < this.dataOrderCopy.length; i++) {
          flag =
            flag && // si el paquete fue evaluado y tiene reposiciones generadas estas deben haber pasado por la evaluacion de autorizacion o en caso no haya reposiciones generadas no pasa nada
            (this.dataOrderCopy[i].attributes.evaluated == 1 )
          if (!flag) break
        }
      }else{
        flag = false
      }


      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// shipment-evaluatePackage-view.vue?1f5bede2